import PinTransferSuccess from "../../Component/EPin/PinTransferSuccess";
const PinTransferSuccesspage = () => {
  return (
    <div className='page-body'>
      <PinTransferSuccess />
    </div>
  )
}

export default PinTransferSuccesspage